import { Download, FileText, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Empty } from "@/components/common";
import { downloadDoc, errMsg, fmtDate, fmtSize } from "@/lib/api";

export default function DocumentsList({ items, pages, onDelete }) {
  if (!items.length) return <Empty text="Nessun documento disponibile." />;
  const pageName = (id) => pages?.find((p) => p.id === id)?.title;
  const dl = async (d) => {
    try {
      await downloadDoc(d);
      toast.success(`Download avviato: ${d.filename}`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <ul className="divide-y divide-slate-800">
      {items.map((d) => (
        <li key={d.id} className="flex items-center gap-4 px-5 py-3.5 hover:bg-slate-800/30 transition-colors" data-testid={`document-row-${d.id}`}>
          <div className="h-10 w-10 shrink-0 rounded-md bg-blue-500/10 border border-blue-500/20 grid place-items-center text-blue-400">
            <FileText size={18} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="font-medium truncate">{d.title}</div>
            <div className="text-xs text-slate-500 truncate">
              {d.filename} · {fmtSize(d.size)} · {fmtDate(d.created_at)}
              {pages && pageName(d.page_id) ? ` · ${pageName(d.page_id)}` : ""}
            </div>
          </div>
          <Button size="sm" variant="outline" className="border-slate-700 bg-transparent" onClick={() => dl(d)} data-testid={`download-doc-button-${d.id}`}>
            <Download size={15} className="mr-1.5" />Scarica
          </Button>
          {onDelete && (
            <Button size="icon" variant="ghost" className="text-rose-400" onClick={() => onDelete(d)} data-testid={`delete-doc-button-${d.id}`}>
              <Trash2 size={15} />
            </Button>
          )}
        </li>
      ))}
    </ul>
  );
}
